export default {
    props: {
        allowCopyDelimeter: {
            type: String | Object,
            default: undefined,
            kComposite: 'allowCopy.delimeter'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-grid-vue-wrapper/src/KendoGrid/AllowCopy.js